export default __webpack_public_path__ + "static/media/Sign Up Login Image.327bd6f4.jpg";